import type { IGenericPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import withAuthentication from '@on3/ui-lib/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/hocs/withValidUrl';
import { ContactInfo } from '@public/components/Contact/ContactInfo';
import { PageWrapper } from '@public/components/Layouts/PageWrapper';
import type { GetServerSideProps } from 'next';

const Contact = (props: IGenericPageProps) => {
  return (
    <PageWrapper {...props} title="Contact | On3.com">
      <ContactInfo />
    </PageWrapper>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      pageType: 'page',
      siteData: siteData || [],
      userData: userData || {},
    },
  };
};

export default withValidUrl(Contact);
